export default function Dateconvertthai(strdate) {

    let datesplit = strdate.substring(0, 10);
    let datesplit1 = datesplit.split("-")
    // console.log(datesplit2[0])
    // console.log(datesplit2[1])
    // console.log(datesplit2[2].slice(0, 2)) 
    let docdatenew = datesplit1[2] + "/" + datesplit1[1] + "/" + (Number(datesplit1[0]) + 543)
    console.log("Dateconvertthai", datesplit);
    return docdatenew
}